import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, effect, input, ViewChildren, QueryList, ElementRef, AfterViewInit, ChangeDetectorRef, HostListener } from '@angular/core';
import { stepService } from 'src/app/services/step.service';
import { firstValueFrom } from 'rxjs';
import { generalService } from 'src/app/services/general-info';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Status } from 'src/app/helper/enum';
import { CustomDatePipe } from 'src/app/pipe/date-format.pipe';
import { formatDurationFromSeconds } from 'src/app/helper/general.helper';
import { MatDialog } from '@angular/material/dialog';
import { DialogComponent } from '../dialog/confirm.dialog';
import { STEP_TYPES } from 'src/app/admissions/pipelines/step-add-edit/step-add-edit.component';
import { TagsCacheService } from 'src/app/services/cache/tags-cache';
import { MatIcon } from '@angular/material/icon';
import { EnrollmentModalComponent } from '../enrollment-modal/enrollment-modal.component';  // ← NEW
import { CommunicationService } from '@app/leads/leads-managment/signal-lead.serice';

@Component({
  selector: 'app-stepper-purecss',
  standalone: true,
  imports: [CommonModule, MatTooltipModule, CustomDatePipe, MatIcon],
  templateUrl: './stepper-purecss.component.html',
  styleUrl: './stepper-purecss.component.scss',
})
export class StepperPurecssComponent implements OnInit, AfterViewInit {
  @ViewChildren('stepElement') stepElements!: QueryList<ElementRef>;

  leadTags = input<any[]>([]);
  @Output() tagsChanged = new EventEmitter<{action: 'add' | 'remove', tagId: number}>();
  
  hoveredIndex: number | null = null;

  availableTags: any[] = [];
  showTagDropdown = false;
  isDuplicated = input<boolean>(false);
  faAdvisorId = input<number | null>(null);

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    this.showTagDropdown = false;
  }

  constructor(
    private currentStep: stepService,
    private generalService: generalService,
    private cdr: ChangeDetectorRef,
    private dialog: MatDialog,
    private tagsCacheService: TagsCacheService,
    private communicationService:CommunicationService
  ) {
    effect(() => {
      const currentLeadId = this.leadId();
      const pipeline = this.pipelineId();
      const currentStepId = this.currentStepId();
  
      const leadIdChanged = currentLeadId !== this.idLead;
      const pipelineChanged = pipeline !== this.previousPipelineId;
      const currentStepIdChanged = currentStepId !== this.previousStepId;
      
      if (!this.isInitialized) {
        return;
      }
      
      if (leadIdChanged || pipelineChanged || currentStepIdChanged) {
        this.previousPipelineId = pipeline;
        this.previousStepId = currentStepId;
        this.activity_time = this.lastActivityTime();
        
        this.generateData();
        return;
      }
      
      const lastActivityTimeChanged = new Date(this.lastActivityTime()).getTime() !== new Date(this.activity_time).getTime();
      if (lastActivityTimeChanged) {
        this.activity_time = this.lastActivityTime();
        
        if (this.steps?.length > 0) {
          this.updateStepsForActivityTime();
        }
      }
    });
  }

  @Input() set leadStatus(data: string) {
    this.findStatus(data);
  }

  // Use setter to properly track isEnrolled changes from parent
  private _isEnrolledInput: any;
  @Input() 
  set isEnrolled(value: any) {
    this._isEnrolledInput = value;
    this._isEnrolled = !!value && String(value).trim() !== "";
  }
  get isEnrolled(): any {
    return this._isEnrolledInput;
  }

  enrolledAt = input<any>(null);
  startAt = input<any>(null);
  
  pipelineId = input<any>();
  leadId = input<any>();
  currentStepId = input<any>();
  lastActivityTime = input<any>();
  admissionStatus = input<string>('draft');                           // ← NEW

  @Output() newStep = new EventEmitter<any>();

  isOnEnrolledStep: boolean = false;
  _isEnrolled = false;
  
  steps: any;
  actual_steps: any;
  activeStep: any;
  CurrentName: string;
  idLead: any;
  isLost: boolean = false;
  isWon: boolean = false;
  currentStepIndex = 0;
  activity_time: any;
  private isInitialized = false;
  private previousPipelineId: any = null;
  private previousStepId: any = null;

  async ngOnInit() {
    this.previousPipelineId = this.pipelineId();
    this.previousStepId = this.currentStepId();

    this._isEnrolled = !!this.isEnrolled && String(this.isEnrolled).trim() !== "";
    
    await this.generateData();

    this.tagsCacheService.fetchData();
    this.tagsCacheService.data$.subscribe(tags => {
      this.availableTags = tags || [];
    });
    
    this.isInitialized = true;
  }

  ngAfterViewInit() {}

  updateStepsForActivityTime() {
    if (!this.steps || !this.actual_steps) {
      return;
    }
    
    const leadStepsMap: any = new Map(this.actual_steps.map(item => [item.step_id, item]));
    this.steps = this.steps.map((row, index) => 
      this.mapStepFields(row, index, leadStepsMap, this.activity_time)
    );
  }

  async generateData(steps?: any) {
    this.idLead = this.leadId();
    
    if (!this.idLead) {
      return;
    }

    try {
      const [response_step, response_lead_step] = await Promise.all([
        firstValueFrom(this.currentStep.get({ id: this.pipelineId() }, 'by-pipeline')),
        firstValueFrom(this.generalService.get({ lead: this.idLead }, 'lead-step'))
      ]);
      
      this.steps = response_step;
      this.actual_steps = response_lead_step?.stepDurations || [];
      
      const foundIndex = this.steps.findIndex(row => row.id === this.currentStepId());
      this.currentStepIndex = foundIndex === -1 ? 0 : foundIndex;

      this.isOnEnrolledStep = this.steps[this.currentStepIndex]?.step_type === STEP_TYPES.ENROLLED;

      if (!this._isEnrolled && this.isOnEnrolledStep) {
        this._isEnrolled = true;
      }

      const leadStepsMap: any = new Map(this.actual_steps.map(item => [item.step_id, item]));
      this.steps = this.steps.map((row, index) => this.mapStepFields(row, index, leadStepsMap, response_lead_step?.lastActivityTime));

    } catch (error) {
      console.error('[STEPPER] Error generating data:', error);
    }
  }

  mapStepFields(row, index, leadStepsMap, lastActivityTime?: any) {
    const lead_step = leadStepsMap.get(row.id);
    const { days, hours, minutes } = lead_step 
      ? formatDurationFromSeconds(lead_step.total_duration) 
      : { days: 0, hours: 0, minutes: 0 };

    const currentDate = new Date();
    const activityDate = new Date(lastActivityTime || this.activity_time);
    
    const currentDateOnly = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      currentDate.getDate()
    );
    const activityDateOnly = new Date(
      activityDate.getFullYear(),
      activityDate.getMonth(),
      activityDate.getDate()
    );
    
    const diffInTime = currentDateOnly.getTime() - activityDateOnly.getTime();
    const diffInDaysLastActivity = Math.floor(diffInTime / (1000 * 60 * 60 * 24));
    
    this.activity_time = lastActivityTime;
  
    const isOverdue = this.currentStepIndex == index && 
                     row.enable_rotting_days && 
                     diffInDaysLastActivity >= row.rotting_in_days;
                     
    const isActive = !isOverdue && (days > 0 || hours > 0 || minutes > 0);
    
    return {
      ...row,
      diffInDays: days,
      diffInHours: hours,
      diffInMinutes: minutes,
      isOverdue,
      isActive,
      futureStep: index > this.currentStepIndex,
      existLeadStep: !!lead_step,
    };
  }

  // ════════════════════════════════════════════════════════════════
  //  CHANGE STEP — modified to open enrollment modal for ENROLLED
  // ════════════════════════════════════════════════════════════════
  async changeStep(index: any) {    
    if (index === this.currentStepIndex) {
      return;
    }
    
    const targetStep = this.steps[index];

    if (this.isLost) {
      this.dialog.open(DialogComponent, {
        width: '400px',
        data: {
          header: 'Cannot Move Step',
          content: 'You cannot change steps on a lost lead. Please reopen the lead first.',
          isInfo: true,
          type: 'warning'
        }
      });
      return;
    }

    // ========== ADD THIS ==========
    if (this.isDuplicated()) {
      this.dialog.open(DialogComponent, {
        width: '400px',
        data: {
          header: 'Cannot Move Step',
          content: 'You cannot change steps without first resolving the duplicate. Please merge or separate the duplicated leads first.',
          isInfo: true,
          type: 'warning'
        }
      });
      return;
    }
    // ==============================

    let extraPayload: any = {};

    // ── If target step is ENROLLED, open enrollment modal first ──
    if (targetStep.step_type === STEP_TYPES.ENROLLED) {
      const dialogRef = this.dialog.open(EnrollmentModalComponent, {
        width: '400px',
        disableClose: true,
        data: { title: 'Start Date', mode: 'enroll', fa_advisor_id: this.faAdvisorId() ?? null }
      });

      const result = await firstValueFrom(dialogRef.afterClosed());
      if (!result) return; // User cancelled

      extraPayload = {
        start_at: result.start_at instanceof Date
          ? result.start_at.toISOString()
          : new Date(result.start_at).toISOString(),
        ...(result.note ? { note: result.note } : {}),
        fa_advisor_id: result.fa_advisor_id ?? null,  // ← always sent, even when null (to clear it)
      };
    }

    // ── Build payload ──
    const hasStepHistory = this.actual_steps && this.actual_steps.length > 0;
    
    const prevId = hasStepHistory && this.currentStepIndex >= 0 && this.steps[this.currentStepIndex]
      ? +this.steps[this.currentStepIndex].id
      : null;
    
    const obj = {
      current_step_id: +targetStep.id,
      leadId: +this.idLead,
      step_type: targetStep.step_type,
      prevId,
      ...extraPayload,
    };
    
    try {
      const response = await firstValueFrom(
        this.generalService.put(obj, obj.leadId, 'lead-step'),
      );
      
      // ✅ Update enrolled status from API response
      if (response?.enrolled_at) {
        this._isEnrolled = true;
      } else if (response?.enrolled_at === null) {
        this._isEnrolled = false;
      }
      
      // ✅ Update whether we're on an enrolled step
      this.isOnEnrolledStep = targetStep.step_type === STEP_TYPES.ENROLLED;
      
      const findIndex = this.actual_steps.findIndex(
        (a_step) => a_step.step_id == targetStep.id,
      );
      
      if (findIndex === -1) {
        this.actual_steps.push({ step_id: targetStep.id, total_duration: 10 });
      }
      
      this.currentStepIndex = index;
      const leadStepsMap: any = new Map(this.actual_steps.map(item => [item.step_id, item]));
      this.steps = this.steps.map((row, idx) => this.mapStepFields(row, idx, leadStepsMap, new Date()));
      
      // ✅ Update stepper's own lost/won state immediately
      if (response?.status) {
        this.findStatus(response.status);
      }

      // ✅ Emit with admission_status, start_at, AND status
      this.newStep.emit({ 
        step: this.steps[index], 
        last_activity_time: new Date(),
        enrolled_at: response?.enrolled_at,
        admission_status: response?.admission_status,
        start_at: response?.start_at,
        status: response?.status,
        fa_advisor_id: response?.fa_advisor_id,
        faAdvisor: response?.faAdvisor,
      });
      

      if (response?.note) {
        this.communicationService.sendOneTimeSignal({
          type: 'note-added-external',
          obj: { data: response.note },
        });
      }

      this.activeStep = response;
  
    } catch (error) {
      console.error('[STEPPER] Error changing step:', error);
    }
  }

  // ════════════════════════════════════════════════════════════════
  //  ENROLL LEAD — public method for parent "Enroll" button
  // ════════════════════════════════════════════════════════════════
  async enrollLead() {
    if (!this.steps?.length) return;

    const enrolledIndex = this.steps.findIndex(
      (s: any) => s.step_type === STEP_TYPES.ENROLLED
    );
    if (enrolledIndex === -1) return;

    await this.changeStep(enrolledIndex);
  }

  onStepHover(index: number) {
    this.hoveredIndex = index;
  }

  onStepLeave() {
    this.hoveredIndex = null;
  }

  isNearHovered(index: number): boolean {
    if (this.hoveredIndex === null) return false;
    const distance = Math.abs(index - this.hoveredIndex);
    return distance > 0 && distance <= 2;
  }

  isFarFromHover(index: number): boolean {
    if (this.hoveredIndex === null) return false;
    return Math.abs(index - this.hoveredIndex) > 2;
  }

  getStepTooltip(step) {
    if (!step.existLeadStep) {
      return `${step.name} - This lead has not been here yet`;
    }
    if (step.diffInDays > 0) {
      const timeLabel = step.diffInDays === 1 ? 'day' : 'days';
      return `${step.name} - Been here for ${step.diffInDays} ${timeLabel}`;
    }
    if (step.diffInHours > 0) {
      const timeLabel = step.diffInHours === 1 ? 'hour' : 'hours';
      return `${step.name} - Been here for ${step.diffInHours} ${timeLabel}`;
    }
    if (step.diffInMinutes > 0) {
      return `${step.name} - Been here for ${step.diffInMinutes} min`;
    }
    return `${step.name} - Been here for a few seconds`;
  }


  // ════════════════════════════════════════════════════════════════
  //  ADMISSION STATUS HELPERS
  // ════════════════════════════════════════════════════════════════
  isEnrolledState(): boolean {
    const status = this.admissionStatus() || 'draft';
    return ['enrolled', 'pushed', 'started', 'not_started'].includes(status);
  }

  getAdmissionLabel(): string {
    const enrolled = this.enrolledAt();
    const startAt = this.startAt();
    const enrolledDate = enrolled ? this.formatShortDate(enrolled) : '';
    const startDate = startAt ? this.formatShortDate(startAt) : '';
  
    switch (this.admissionStatus()) {
      case 'enrolled':
        return [
          enrolledDate ? `Enrolled: ${enrolledDate}` : 'Enrolled',
          ...(startDate ? [`Planned Start: ${startDate}`] : []),
        ].join(' · ');
      case 'pushed':
        return [
          enrolledDate ? `Enrolled: ${enrolledDate}` : 'Enrolled',
          startDate ? `Pushed: ${startDate}` : 'Pushed',
        ].join(' · ');
      case 'started':
        return [
          enrolledDate ? `Enrolled: ${enrolledDate}` : 'Enrolled',
          startDate ? `Started: ${startDate}` : 'Started',
        ].join(' · ');
      case 'not_started':
        return 'Not Started';
      default:
        return '';
    }
  }
  
  private formatShortDate(date: any): string {
    const d = new Date(date);
    if (isNaN(d.getTime())) return '';
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  }

  getAdmissionBadgeClass(): string {
    return 'badge-' + (this.admissionStatus() || 'draft');
  }

  findStatus(data) {
    if (data === Status.LOST) {
      this.isLost = true;
      this.isWon = false;
    } else if (data === Status.WON) {
      this.isWon = true;
      this.isLost = false;
    } else {
      this.isWon = false;
      this.isLost = false;
    }
  }

  get unassignedTags(): any[] {
    const currentTagIds = (this.leadTags() || []).map(lt => lt.tag_id || lt.tag?.id);
    return this.availableTags.filter(tag => !currentTagIds.includes(tag.id));
  }

  addTag(tag: any) {
    this.tagsChanged.emit({ action: 'add', tagId: tag.id });
    this.showTagDropdown = false;
  }

  removeTag(leadTag: any, event: Event) {
    event.stopPropagation();
    this.tagsChanged.emit({ action: 'remove', tagId: leadTag.tag_id || leadTag.tag?.id });
  }

  toggleTagDropdown(event: Event) {
    event.stopPropagation();
    this.showTagDropdown = !this.showTagDropdown;
  }

  closeTagDropdown() {
    this.showTagDropdown = false;
  }
}